// extracted by mini-css-extract-plugin
module.exports = {"container":"layouts-main-container","fullscreen":"layouts-main-fullscreen","inner":"layouts-main-inner"};